import React from "react";
import { Modal } from "react-bootstrap";
import logout from "../../images/logout-icon.png";
import OneSignal from "react-onesignal";

export const onClickLogoutBtn = () => {
  OneSignal.setSubscription(false);
  localStorage.clear();
  window.location.href = "/login";
};

const LogoutPopup = (props) => {
  return (
    <Modal
      className="logoutpop"
      {...props}
      size="lg"
      aria-labelledby="contained-modal-title-vcenter"
      centered
    >
      <Modal.Header closeButton></Modal.Header>
      <Modal.Body>
        <h4>Are you sure you want to log out?</h4>
        <div className="logout-image">
          <img src={logout} alt="logout background" />
        </div>

        <div className="logoutpop-body">
          <div className="cancel-popup">
            <button onClick={props.onHide}>cancel</button>
          </div>
          <div className="logout-popup">
            <button onClick={onClickLogoutBtn}>Yes, logout</button>
          </div>
        </div>
      </Modal.Body>
    </Modal>
  );
};
export default LogoutPopup;
